import React from 'react';
import { Card, Button } from "react-bootstrap";
import { Link } from 'react-router-dom';
import ImageBlock from '../ImageBlock/imageBlock.component'
import { FaInfoCircle } from "react-icons/fa";

import './collegeCard.module.css';
import { LinkContainer } from 'react-router-bootstrap';

const CollegeCard = ({banner, title, location, link}, ...props) => {
    return (
        <Card styleName="college-card">
            {/* <ImageBlock ratio={[530,280]} banner={ !!banner && banner } /> */}
            <ImageBlock
                width={530}
                height={280}
                src={banner}
            />
            {/* <Card.Img styleName="college-card-banner" variant="top" src={ !!banner && banner } /> */}
            <Card.Body styleName="college-card-body">
                <LinkContainer to={ !!link && link }>
                    <Button styleName="info-link" className="shadow">
                        <div className="shadow" styleName="info-link-icon">
                            <FaInfoCircle />
                        </div>
                        <span>বিস্তারিত</span>
                    </Button>
                </LinkContainer>
                <Card.Title className="mb-1" styleName="college-card-title">
                    <Link to={ !!link && link }>
                        { !!title && title }
                    </Link>
                </Card.Title>
                <Card.Text className="text-black-50" styleName="college-card-location">
                    { !!location && location }
                </Card.Text>
            </Card.Body>
        </Card>
    )
}

export default CollegeCard;